/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayslipThemeColors } from './PlayslipThemeColors';
import {
    PlayslipThemeColorsFromJSON,
    PlayslipThemeColorsFromJSONTyped,
    PlayslipThemeColorsToJSON,
} from './PlayslipThemeColors';

/**
 * A customer's named playslip theme.
 * @export
 * @interface PlayslipTheme
 */
export interface PlayslipTheme {
    /**
     * 
     * @type {Date}
     * @memberof PlayslipTheme
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlayslipTheme
     */
    createdAt: Date;
    /**
     * Playslip copy the customer reworded, keyed by message. A key left out shows the app's built-in
     * text. Words in braces, like {count}, are filled in by the app.
     * @type {{ [key: string]: string; }}
     * @memberof PlayslipTheme
     */
    messages: { [key: string]: string; };
    /**
     * The retailer's logo, shown beside the lottery's in the playslip header. Null when the theme has none.
     * @type {string}
     * @memberof PlayslipTheme
     */
    partnerLogoUrl: string | null;
    /**
     * 
     * @type {PlayslipThemeColors}
     * @memberof PlayslipTheme
     */
    colors: PlayslipThemeColors;
    /**
     * Customer-authored and fixed at creation; a host app sends it to select this theme.
     * @type {string}
     * @memberof PlayslipTheme
     */
    themeId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PlayslipTheme
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PlayslipTheme
     */
    id: string;
}

/**
 * Check if a given object implements the PlayslipTheme interface.
 */
export function instanceOfPlayslipTheme(value: object): value is PlayslipTheme {
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('partnerLogoUrl' in value) || value['partnerLogoUrl'] === undefined) return false;
    if (!('colors' in value) || value['colors'] === undefined) return false;
    if (!('themeId' in value) || value['themeId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PlayslipThemeFromJSON(json: any): PlayslipTheme {
    return PlayslipThemeFromJSONTyped(json, false);
}

export function PlayslipThemeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayslipTheme {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedAt': (new Date(json['updatedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'messages': json['messages'],
        'partnerLogoUrl': json['partnerLogoUrl'],
        'colors': PlayslipThemeColorsFromJSON(json['colors']),
        'themeId': json['themeId'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function PlayslipThemeToJSON(value?: PlayslipTheme | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'messages': value['messages'],
        'partnerLogoUrl': value['partnerLogoUrl'],
        'colors': PlayslipThemeColorsToJSON(value['colors']),
        'themeId': value['themeId'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

